<template>
  <div class="inventory-history-modal-wrapper">
    <div
      class="inventory-history-modal"
      :class="{ small: !id && !location.company && !location.project }"
    >
      <template v-if="!id && !location.company && !location.project">
        <header class="inventory-history-modal__header">
          <p>Избери проект</p>
          <span class="mck" @click="$emit('close')">F</span>
        </header>
        <main>
          <CompaniesTree
            :showActiveProjects="true"
            :justSelecting="true"
            @selected="handleSelectedProject"
          />
        </main>
      </template>

      <template v-else>
        <header
          class="inventory-history-modal__header inventory-history-modal__header--back"
        >
          <p>
            <span
              class="mck back"
              @click="location = {}"
              v-if="location.company"
              >e</span
            >
            <span>{{ getTitle }}</span>
          </p>
          <span class="mck" @click="$emit('close')">F</span>
        </header>

        <header class="inventory-history-modal__header">
          <SelectPeriod @update="updatePeriod">
            <button
              class="btn btn-excel"
              :disabled="!logs.length"
              @click="getData(true)"
            >
              <!-- @click="exportToExcelFile()" -->
              <span class="mck">E</span>
              ЕКСПОРТ
            </button>
          </SelectPeriod>
        </header>

        <main>
          <table class="table" v-if="userType">
            <thead>
              <tr>
                <th><strong>ДАТА</strong></th>
                <th><strong>ДЕЙСТВИЕ</strong></th>
                <th><strong>НА СЛУЖИТЕЛ</strong></th>
              </tr>
            </thead>
            <hr />
            <tbody v-if="!logs.length">
              <tr>
                <td class="center" colspan="5">НЯМА РЕЗУЛТАТИ</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="l in logs" :key="l._id">
                <td :title="l.date">
                  {{ l.date | formatDate }}
                </td>
                <td style="width: 70%">{{ l.activity }}</td>
                <td>{{ l.user ? l.user.name : "" }}</td>
              </tr>
            </tbody>
          </table>
          <table class="table" v-else-if="childType">
            <thead>
              <tr>
                <th>
                  <strong>ДАТА {{ showEvents ? "ВЪВЕЖДАНЕ" : "" }}</strong>
                </th>
                <th>
                  <strong
                    >{{ showEvents ? "ДАТА АКТУАЛИЗАЦИЯ" : "РАЗХОД, €" }}
                  </strong>
                </th>
                <th>
                  <strong>{{ showEvents ? "БЕЛЕЖКА" : "ВИД" }}</strong>
                </th>
                <th><strong>ОТ СЛУЖИТЕЛ</strong></th>
                <th>
                  <strong>{{ showEvents ? "СТАТУС" : "ЗАБЕЛЕЖКА" }}</strong>
                </th>
              </tr>
            </thead>
            <hr />
            <tbody v-if="!logs.length">
              <tr>
                <td class="center" colspan="5">НЯМА РЕЗУЛТАТИ</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="l in logs" :key="l._id">
                <template v-if="showEvents">
                  <td :title="l.date">
                    {{ l.date | formatDate }}
                  </td>
                  <td :title="l.updatedAt">
                    {{ l.endedAt | formatDate }}
                  </td>
                  <td>{{ l.note }}</td>
                  <td>{{ l.createdBy ? l.createdBy.name : "" }}</td>
                  <td>{{ l.endedAt ? "Оправено" : "Не е оправено" }}</td>
                </template>
                <template v-else>
                  <td :title="l.date">
                    {{ l.date | formatDate }}
                  </td>
                  <td>{{ l.price }}</td>
                  <td>{{ l.activity }}</td>
                  <td>{{ l.createdBy ? l.createdBy.name : "" }}</td>
                  <td>{{ l.note }}</td>
                </template>
              </tr>
            </tbody>
          </table>
          <table class="table" v-else>
            <thead>
              <tr>
                <th v-if="!id"><strong>ИНВЕНТАР</strong></th>
                <th><strong>ДАТА</strong></th>
                <th><strong>СТАТУС</strong></th>
                <th v-if="id"><strong>ЛОКАЦИЯ</strong></th>
                <th><strong>БЕЛЕЖКА</strong></th>
                <th><strong>ОТ СЛУЖИТЕЛ</strong></th>
              </tr>
            </thead>
            <hr />

            <tbody v-if="!logs.length">
              <tr>
                <td class="center" colspan="5">НЯМА РЕЗУЛТАТИ</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="l in logs"
                :key="l._id"
                :class="{ 'grid-row--inv': !id }"
              >
                <td v-if="!id">{{ getInventoryName(l.inventory) }}</td>
                <td :title="l.createdAt">
                  <div class="period">
                    <span class="start">
                      {{ l.createdAt | formatDate }}
                    </span>
                    <span class="end" v-if="l.endedAt">
                      {{ l.endedAt | formatDate }}
                    </span>
                  </div>
                </td>
                <td>{{ statuses[l.status] }}</td>
                <td v-if="id">
                  <template v-if="!l.location">-</template>
                  <template v-else>
                    {{ l.location.companyName }} &gt;
                    {{ l.location.projectName }}
                  </template>
                </td>
                <td>{{ l.confirmNote }}</td>
                <td>{{ l.createdBy ? l.createdBy.name : "" }}</td>
              </tr>
            </tbody>
          </table>
        </main>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectPeriod from "../shared/SelectPeriod.vue";
// import XLSX from "xlsx";
import log from "../mixins/log.js";
import CompaniesTree from "../shared/CompaniesTree.vue";
// import { format } from "date-fns";
export default {
  components: {
    SelectPeriod,
    CompaniesTree,
  },
  mixins: [log],
  props: ["id", "showEvents"],
  computed: {
    ...mapGetters(["getUser"]),
    getTitle() {
      if (this.id) {
        const output = [];
        output.push(this.getInventoryName(this.inventory));
        output.push("ИСТОРИЯ");
        return output.join(" - ");
      } else {
        return `${this.location.companyName} - ${this.location.projectName} - ИСТОРИЯ`;
      }
    },
    locationType() {
      return ["tool", "equipment"].includes(this.inventory.type);
    },
    userType() {
      return ["user_inventory", "pernik"].includes(this.inventory.type);
    },
    childType() {
      return ["heavy_machinery", "car"].includes(this.inventory.type);
    },
  },
  data() {
    return {
      statuses: {
        "": "СВОБОДЕН",
        moving: "ПРЕМЕСТВАНЕ",
        onsite: "НА ОБЕКТ",
        repair: "ЗА РЕМОНТ",
        scrap: "ЗА БРАК",
        missing: "ЛИПСВА?",
      },
      location: {},
      period: {},
      inventory: {},
      logs: [],
    };
  },
  methods: {
    handleSelectedProject(value) {
      this.location = value;
      this.getData();
    },
    updatePeriod(p) {
      this.period = p;
      this.getData();
    },
    getInventoryName(i) {
      if (i.parent) {
        return [i.parent.name, i.parent.brand, i.parent.serialNumber]
          .filter((x) => x)
          .join(" - ");
      } else
        return [i.name, i.brand, i.serialNumber].filter((x) => x).join(" - ");
    },
    getData(getExcel) {
      if (!this.inventory._id && this.id) {
        this.$http
          .get(`${process.env.VUE_APP_BASE_URI}/inventory/${this.id}`)
          .then((response) => {
            this.inventory = response.data;
          });
      }

      if (!getExcel) this.logs = [];

      let url = `${process.env.VUE_APP_BASE_URI}/inventory/logs?l=1`;

      if (this.id) url += `&inventory=${this.id}`;
      if (getExcel) url += `&getExcel=true`;
      if (this.showEvents) url += `&isEvent=${this.showEvents}`;

      if (this.period.dateFrom && this.period.dateTo) {
        url += `&dateFrom=${this.period.dateFrom.toISOString()}`;
        url += `&dateTo=${this.period.dateTo.toISOString()}`;
      }

      if (this.location.company && this.location.project) {
        url += `&company=${this.location.company}`;
        url += `&project=${this.location.project}`;
      }

      this.$http.get(url).then(async (response) => {
        if (getExcel) {
          const response = await this.$http.get(url, { responseType: "blob" });

          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Справка-инвентар.xlsx";
          link.click();
        } else {
          this.logs = response.data;
        }
      });
    },
    // getExportData() {
    // const formatPrice = (price) => {
    //   return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    // };

    // const exportData = this.logs.map((l) => {
    //   let row;

    //   if (this.childType) {
    //     row = {
    //       Дата: format(new Date(l.date), "dd.MM.yyyy"),
    //       "Разход стойност": `${formatPrice(l.price)} €`,
    //       Вид: l.activity,
    //       "От служител": l.createdBy ? l.createdBy.name : "",
    //       Забележка: l.note,
    //     };
    //   } else if (this.locationType) {
    //     row = {
    //       Инвентар: this.getInventoryName(l.inventory),
    //       "Дата от": l.createdAt ? new Date(l.createdAt) : undefined,
    //       "Дата до": l.endedAt ? new Date(l.endedAt) : undefined,
    //       Статус: this.statuses[l.status],
    //       Локация: l.location
    //         ? `${l.location.companyName} > ${l.location.projectName}`
    //         : undefined,
    //       "От служител": l.createdBy ? l.createdBy.name : "",
    //     };
    //   } else if (this.userType) {
    //     row = {
    //       Дата: format(new Date(l.date), "dd.MM.yyyy"),
    //       Действие: l.activity,
    //       "От служител": l.user ? l.user.name : "",
    //     };
    //   }

    //   return row;
    // });

    // if (this.childType) {
    //   const totalPrice = this.logs.reduce(
    //     (sum, l) => sum + (l.price || 0),
    //     0
    //   );

    //   exportData.push(
    //     {},
    //     {
    //       Дата: "Общо",
    //       "Разход стойност": `${formatPrice(totalPrice)} €`,
    //     }
    //   );
    // }

    // return exportData;
    // },
    // exportToExcelFile() {
    //   const wscols = [
    //     { wpx: 200 },
    //     { wpx: 100 },
    //     { wpx: 100 },
    //     { wpx: 100 },
    //     { wpx: 200 },
    //     { wpx: 200 },
    //   ];

    //   const config = { dateNF: "dd/mm/yyyy" };

    //   const workersWorksheet = XLSX.utils.json_to_sheet(
    //     this.getExportData(),
    //     config
    //   );

    //   const new_workbook = XLSX.utils.book_new();

    //   workersWorksheet["!cols"] = wscols;

    //   // Append Worksheet
    //   XLSX.utils.book_append_sheet(new_workbook, workersWorksheet, "Инвентар");
    //   // Save File

    //   XLSX.writeFile(new_workbook, `Справка-инвентар.xlsx`);
    // },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$emit("close", { isEdited: isEdited });
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        this.submit();
      } else if (e.code === "Escape") {
        this.closeModal(false);
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleEvents);

    if (this.id) {
      this.getData();
    }
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped lang="scss">
.inventory-history-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5;
}

.inventory-history-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #6d2600; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  /* padding: 10px 20px 0; */
  width: 920px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}

.inventory-history-modal.small {
  width: 362px;
}

.inventory-history-modal__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem 0;
  /* text-align: center; */
}

.inventory-history-modal__header > p {
  align-items: center;
  display: flex;
}

.inventory-history-modal__header .back {
  cursor: pointer;
  font-weight: 400;
  opacity: 0.5;
  margin-right: 0.5rem;
}

.inventory-history-modal__header .back:hover {
  opacity: 1;
}

.inventory-history-modal.small .inventory-history-modal__header {
  padding-bottom: 1rem;
}
.inventory-history-modal__header > p {
  font-size: 13px;
  font-weight: 700;
}
.inventory-history-modal__header .mck {
  cursor: pointer;
  user-select: none;
}
.inventory-history-modal__header .mck:hover {
  opacity: 0.8;
}

// .grid-row {
//   display: grid;
//   grid-template-columns: 1fr 1fr 3fr 1fr 2fr;
//   width: 100%;
// }
// .grid-row--inv {
//   grid-template-columns: 3fr 1fr 1fr 1fr 2fr;
// }

.inventory-history-modal > main {
  max-height: 50vh;
  min-height: 50vh;
  overflow: auto;
}

.inventory-history-modal.small > main {
  background: #f0f0f7;
  min-height: initial;
  padding: 7px;
}

// main > .grid-row {
//   border-bottom: 1px solid #c2d0e2;
//   padding-left: 10px;
// }

// main.center {
//   align-items: center;
//   display: flex;
//   justify-content: center;
//   padding: 1rem;
//   text-align: center;
// }

// .grid-row span {
//   align-items: center;
//   display: inline-flex;
//   height: 35px;
//   padding: 4px 10px;
// }

// .logs-container {
//   max-height: 50vh;
//   overflow: auto;
//   padding: 6px 0 10px;
// }
// .logs-container .grid-row {
//   margin-top: 4px;
//   padding-left: 10px;
//   padding-right: 10px;
// }
// .logs-container .grid-row span {
//   background: #ececec;
// }
// .logs-container .grid-row > span:first-child {
//   border-bottom-left-radius: 4px;
//   border-top-left-radius: 4px;
// }
// .logs-container .grid-row > span:last-child {
//   border-bottom-right-radius: 4px;
//   border-top-right-radius: 4px;
// }
// .logs-container .grid-row span.period {
//   display: flex;
//   align-items: flex-start;
//   flex-direction: column;
// }
// span.period .start {
//   color: #217346;
// }
// span.period .end {
//   color: #8d3506;
// }
// .logs-container .grid-row span span {
//   padding: 0;
// }
table {
  padding: 0 10px;
  position: relative;

  tr {
    td {
      background: #ececec;
      cursor: default;
      height: 35px;
    }

    th {
      background: #ffffff;
      border-radius: initial !important;
    }
  }

  hr {
    border: none;
    background-color: #c2d0e2;
    height: 1px;
    opacity: 0.5;
    left: -5px;
    margin-top: -5px;
    position: absolute;
    width: calc(100% + 5px);
  }

  .period {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    .start {
      color: #217346;
    }
    .end {
      color: #8d3506;
    }
  }
}
/* Responsive */
@media screen and (max-width: 900px) {
  .inventory-history-modal {
    width: 90%;

    .inventory-history-modal__header--back {
      flex-direction: row;
    }

    table {
      min-width: 800px;
    }
  }
}
@media screen and (max-width: 700px) {
  .inventory-history-modal.inventory-history-modal-small {
    width: 90%;
  }
}

@media screen and (max-height: 550px) {
  .inventory-history-modal {
    height: 100%;
  }
}
</style>
